import { DateRange } from '../date-ranges-input/date-ranges-input.component';

export function sortDateRanges(dateRanges: DateRange[]): DateRange[] {
  // new array reference for Change detection
  return [...dateRanges].sort((a, b) => {
    if (!a.from || !b.from) {
      return 0;
    }
    return a.from.getTime() - b.from?.getTime();
  });
}
